export default __webpack_public_path__ + "static/media/info-light.e509f20f.svg";